export class TicketReplyTemplate {
	public id:number = 0;
	public adminId:number = 0;
	public name:string = "Nieuwe template";
	public content:string = "";
	public external:boolean = false;
	public eventId:number = 0;
	public triggerHook:boolean = false;

	public constructor(data?:any){
		if (!data) return;
		this.id = data.id;
		this.adminId = data.adminId;
		this.name = data.name;
		this.content = data.content;
		this.external = data.external;
		this.triggerHook = data.triggerHook;
		this.eventId = data.eventId;
	}

	public getJSON():any{
		return {
			id: this.id,
			adminId: this.adminId,
			name: this.name,
			content: this.content,
			external: this.external,
			triggerHook: this.triggerHook,
			eventId: this.eventId
		};
	}
}